<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-2"></a>
<a id="VPS-3"></a>
<h1 class="title1">A HISTORY OF DEATH IN</h1>
<h1 class="title2"><strong class="b">17TH CENTURY ENGLAND</strong></h1>
<h2 class="author">BEN NORMAN</h2>
<div class="img_container"><img alt="image" class="wid" src="images/Img_3_001.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6e6477b2